export default __webpack_public_path__ + "static/media/nhlfantasychallengecardbg.734b6683.png";